import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { Race } from '../../enums';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'race',
  standalone: false
})
export class RacePipe implements PipeTransform {
  public transform(value: Race): string {
    return getRace(value);
  }
}

export function getRace(value: Race): string {
  switch (value) {
    case Race.White:
      return 'White';
    case Race.Mixed:
      return 'Mixed';
    case Race.Black:
      return 'Black';
    case Race.Asian:
      return 'Asian';
    case Race.Hispanic:
      return 'Hispanic';
    case Race.NativeAmerican:
      return 'Native American';
    default:
      throw new Error(`Unsupported value for Race: ${value}.`);
  }
}

export function getRaceList(): IdName[] {
  return enumToList(Race, getRace);
}
